export default class MineMode {
    /**
     * 
     * @param {string} id 
     * @param {string} name 
     * @param {string} iconFileName
     */
    constructor(id, name, iconFileName) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
        /**
         * @constant
         * @type {string}
         */
        this.name = name;
        /**
         * @constant
         * @type {string}
         */
        this.iconFileName = iconFileName;
    }
}